import footer from "../Styles/Footer.module.scss";
import { Col, Container, Form, Row } from "react-bootstrap";

const Footer = () => {
  const currentDate = new Date();
  const year = currentDate.getUTCFullYear();
  // const month = currentDate.getUTCMonth() + 1;
  // const day = currentDate.getUTCDate();
  // const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day.toString().padStart(2, "0")}`;

  return (
    <div className={footer.footer}>
      <Container fluid>
        <Row>
          <Form.Group as={Col} md={12}>
            <div className={footer.innerFooter}>
              <p>
                <i className="fas fa-copyright" /> {year} CopyRight | Galaxbiotech®
              </p>
              <p>V2.0.0</p>
            </div>
          </Form.Group>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
